/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-param-reassign,max-len */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IExpertItem } from 'pages/profile/interface';
import {
  UpdateGroupState,
  IUpdateGroupForm,
  GetExpertsResponse,
  IExpertFilterPayload,
  ISessionItem,
  IArticleItem,
  IExpertGroupDetails,
  GroupDocument,
  IGroupUsersFilterResponse,
  IGroupUsersFilterPayload,
} from '../interface';

export const initialState: UpdateGroupState = {
  loading: false,
  group: {
    id: '',
    groupType: 'public',
    groupVisibility: 'public',
    subscriptionFee: '0.00',
    subscriptionFrequency: 'monthly',
    currency: 'AUD',
    password: '',
    invitePeople: [],
    title: '',
    subTitle: '',
    description: '',
    bannerImgUrl: '',
    sponsorContent: [],
    experts: [],
    articles: [],
    sessions: [],
    content: [],
    groupAdmin: '-',
  },
  expertResult: {
    result: [],
    total: 0,
  },
  users: { users: [], total: 0 },
};

export const groupUpdateSlice = createSlice({
  name: 'feature/groups/update',
  initialState,
  reducers: {
    // eslint-disable-next-line unused-imports/no-unused-vars
    fetchGroupDetails(state: UpdateGroupState, action: PayloadAction<{ id: string }>) {
      state.loading = true;
    },
    fetchGroupDetailsSucceeded(state: UpdateGroupState, action: PayloadAction<GroupDocument>) {
      state.loading = false;
      const group = action.payload;
      state.group.id = group._id || '';
      state.group.groupType = group.groupType || 'public';
      state.group.groupVisibility = group.groupVisibility || 'public';
      state.group.subscriptionFee = group.subscriptionFee || '0.00';
      state.group.subscriptionFrequency = group.subscriptionFrequency || 'monthly';
      state.group.currency = group.currency || 'AUD';
      state.group.title = group.title || '';
      state.group.subTitle = group.subTitle || '';
      state.group.description = group.description || '';
      state.group.bannerImgUrl = group.bannerImgUrl || '';
      state.group.sponsorContent = group.sponsorContent || [];
      state.group.groupAdmin = group?.groupAdmin ?? '-';
      const experts: IExpertItem[] = [];
      let sessions: ISessionItem[] = [];
      let content: ISessionItem[] = [];
      let articles: IArticleItem[] = [];
      group?.experts?.forEach((expertDetail: IExpertGroupDetails) => {
        if (expertDetail?.expert) {
          experts.push(expertDetail?.expert);
          if (expertDetail?.sessions) {
            sessions = [
              ...sessions,
              ...expertDetail?.sessions?.map((session) => ({
                ...session.session,
              })),
            ];
          }
          if (expertDetail?.contents) {
            content = [
              ...content,
              ...expertDetail?.contents?.map((contentItem) => ({
                ...contentItem?.content,
              })),
            ];
          }
          if (expertDetail?.articles) {
            articles = [
              ...articles,
              ...expertDetail?.articles?.map((article) => ({
                ...article.article,
              })),
            ];
          }
        }
      });
      state.group.experts = experts;
      state.group.sessions = sessions;
      state.group.content = content;
      state.group.articles = articles;
    },
    fetchGroupDetailsFailed(state: UpdateGroupState) {
      state.loading = false;
    },
    updateGroupExperts(state: UpdateGroupState, action: PayloadAction<IExpertItem[]>) {
      state.group.experts = action.payload;
    },
    updateGroupSessions(state: UpdateGroupState, action: PayloadAction<ISessionItem[]>) {
      state.group.sessions = action.payload;
    },
    updateGroupContentOnlySessions(state: UpdateGroupState, action: PayloadAction<ISessionItem[]>) {
      state.group.content = action.payload;
    },
    updateGroupArticles(state: UpdateGroupState, action: PayloadAction<IArticleItem[]>) {
      state.group.articles = action.payload;
    },
    updateGroup(
      state: UpdateGroupState,
      action: PayloadAction<{ id: string; data: IUpdateGroupForm }>,
    ) {
      state.loading = true;
      state.group = action.payload.data;
    },
    updateGroupSucceed(state: UpdateGroupState) {
      state.loading = false;
    },
    updateGroupFailed(state: UpdateGroupState) {
      state.loading = false;
    },
    getGroupExperts(state: UpdateGroupState, action: PayloadAction<IExpertFilterPayload>) {
      state.loading = true;
    },
    getGroupExpertsSucceeded(state: UpdateGroupState, action: PayloadAction<GetExpertsResponse>) {
      state.loading = false;
      const { result, total } = action.payload;
      state.expertResult.result = result;
      state.expertResult.total = total;
    },
    getGroupExpertsFailed(state: UpdateGroupState) {
      state.loading = false;
    },
    getUsers(state: UpdateGroupState, _action: PayloadAction<IGroupUsersFilterPayload>) {
      state.loading = true;
    },
    getUsersSucceeded(state: UpdateGroupState, action: PayloadAction<IGroupUsersFilterResponse>) {
      state.loading = false;
      state.users = action.payload;
    },
    getUsersFailed(state: UpdateGroupState) {
      state.loading = false;
    },
    deleteUser(state: UpdateGroupState, _action: PayloadAction<string>) {
      state.loading = true;
    },
    deleteUserSucceeded(state: UpdateGroupState, action: PayloadAction<string>) {
      const temp = state.users.users.filter((userItem) => userItem.email !== action.payload);
      state.users.users = [...temp];
      state.loading = false;
    },
    deleteUserFailed(state: UpdateGroupState) {
      state.loading = false;
    },
  },
});

export const { actions: groupUpdateActions } = groupUpdateSlice;
